<div class="wrapper mat-elevation-z10">
    <div class="header">
        <span>
            <h1>Client To Bills Transfer</h1>
        </span>
        <div class="toggle">
            <span>C-O transfer</span>
        </div>
    </div>
    <div class="form-container">
        <form [formGroup]="transferFundsForm" #formDirective="ngForm" (ngSubmit)="submit(formDirective)">
            <div class="form">
                <div class="search">
                    <mat-form-field class="matterAuto">
                        <mat-label>Matter</mat-label>
                        @if (transferFundsForm.controls['matter'].value) {
                        <button type="button" (click)="clearSearchFilter()" mat-icon-button matSuffix>
                            <mat-icon>clear</mat-icon>
                        </button>
                        }
                        <input matInput
                               formControlName="matter"
                               [matAutocomplete]="auto" />
                        <mat-error>Please select a Matter.</mat-error>
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete">
                        @if (isLoading) {
                        <mat-option>Loading....</mat-option>
                        } @else if (noData) {
                        <mat-option>No matching matters found.</mat-option>
                        } @else {
                        @for (item of matterDropdownData; track item.number) {
                        <mat-option [value]="displayMatter(item)"
                                    (onSelectionChange)="lookupSelectionChanged($event)">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                        }
                        }
                    </mat-autocomplete>
                </div>

                <mat-form-field>
                    <mat-label>Client</mat-label>
                    <input matInput formControlName="client" [readonly]="!clientEditable" />
                    <mat-error>Please select a client.</mat-error>
                </mat-form-field>

                @if (showLinkToOpenMatter()) {
                <div class="sticky-actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterNo }})
                        </a>
                        <button type="button"
                                mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Client Bank</mat-label>
                    <mat-select formControlName="clientBankAccount" required>
                        @for (account of filteredBankAccounts; track account.id) {
                        <mat-option [value]="account">
                            {{ account.accountId }} - {{ account.description }}
                        </mat-option>
                        }
                    </mat-select>
                    <mat-error>Please select a bank account.</mat-error>
                </mat-form-field>

                @if (showLinkToOpenMatter()) {
                <div class="actionstep-matter-overview">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterOverviewUrl"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Actionstep Matter ({{ matterNo }}) Overview to view linked accounts
                        </a>
                        <button type="button"
                                mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }

                <mat-form-field class="fullLength">
                    <mat-label>Reason for transfer</mat-label>
                    <input matInput formControlName="reason" (input)="onReasonInput()" />
                    <mat-error>Please enter a valid reason for transfer.</mat-error>
                </mat-form-field>

                @if (isUserPartner === false) {
                <div class="fullLength">
                    <mat-form-field>
                        <mat-label>Partner authorising</mat-label>
                        <mat-select formControlName="partnerAuthorisingId">
                            @for (partner of partnerList; track partner.id) {
                            <mat-option [value]="partner.id">
                                {{ partner.name }}
                            </mat-option>
                            }
                        </mat-select>
                        @if (transferFundsForm.get('partnerAuthorisingId')?.hasError('required')) {
                        <mat-error>Partner authorising is required.</mat-error>
                        }
                    </mat-form-field>
                </div>
                }

                <mat-form-field class="halfLength">
                    <mat-label>Payment method</mat-label>
                    <mat-select formControlName="paymentMethod">
                        @for (method of paymentMethodDropdown; track method) {
                        <mat-option [value]="method">{{ method }}</mat-option>
                        }
                    </mat-select>
                    <mat-error>Payment method is required.</mat-error>
                </mat-form-field>

                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Requested Date</mat-label>
                        <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                        <mat-datepicker #requestedDatePicker />
                        @if (transferFundsForm.get('dateRequested')?.touched && transferFundsForm.get('dateRequested')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Requested Time</mat-label>
                        <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                        @if (transferFundsForm.get('requestedTime')?.touched && transferFundsForm.get('requestedTime')?.invalid) {
                        <mat-error>Please enter a time.</mat-error>
                        }
                    </mat-form-field>
                </div>

                @if (bills.length > 0) {
                <mat-table [dataSource]="bills" class="fullLength">
                    <ng-container matColumnDef="pay">
                        <mat-header-cell *matHeaderCellDef>Action Step Balance</mat-header-cell>
                        <mat-cell *matCellDef="let bill">
                            Invoice #{{ bill.ourReference }}
                            (Balance Due: {{ currencySymbol }}{{ bill.totalDue }})
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="warning">
                        <mat-header-cell *matHeaderCellDef>Eligible Payment Amount</mat-header-cell>
                        <mat-cell *matCellDef="let bill">
                            @if (getInvoiceData(bill.ourReference); as invoiceData) {
                            <div class="warning-box">
                                Current Balance for Invoice #{{ bill.ourReference }} is
                                ({{ currencySymbol }}{{ (bill.totalDue - invoiceData.totalAmount) | number:'1.2-2' }})
                            </div>
                            }
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                        <mat-cell *matCellDef="let bill">
                            <mat-form-field class="amountField">
                                <input type="text" matInput [formControlName]="getControlName(bill)"
                                       appCurrencyInput>
                                <mat-error>The entered amount exceeds the total due amount.</mat-error>
                            </mat-form-field>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="fullAmount">
                        <mat-header-cell *matHeaderCellDef>Pay All</mat-header-cell>
                        <mat-cell *matCellDef="let bill">
                            <span class="pay-all-tooltip-target"
                                  [matTooltip]="getEligibleAmount(bill) > 0
                                      ? 'Pay all: ' + currencySymbol + (getEligibleAmount(bill) | number:'1.2-2')
                                      : 'Nothing left to pay on this invoice.'">
                                <mat-checkbox [checked]="isEligibleAmountApplied(bill)"
                                              [disabled]="getEligibleAmount(bill) <= 0"
                                              (change)="onEligibleAmountToggle(bill, $event.checked)"
                                              data-testid="eligible-amount-checkbox">
                                </mat-checkbox>
                            </span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
                }
            </div>

            @if (bills.length > 0) {
            <div class="amount-row">
                <div class="total-amout">Total Amount</div>
                <mat-form-field class="amout">
                    <input type="text" matInput maxlength="12" formControlName="amount" />
                </mat-form-field>
            </div>
            }

            @if (loading) {
            <div class="spinner-container">
                <mat-spinner color="accent" [diameter]="40"></mat-spinner>
            </div>
            }

            @if (noBillsFoundMessage) {
            <div class="no-bills-message">{{ noBillsFoundMessage }}</div>
            }

            @if (isUserPartner) {
            <mat-checkbox class="fullLength" formControlName="fundsCheckedByPartner">
                I confirm that available funds have been checked.<span class="important">*</span>
            </mat-checkbox>
            }

            <div class="action-button">
                <xp-draft-actions [draftName]="draftEditor.draftName()"
                                  [busy]="draftEditor.saving()"
                                  [disabled]="!canSaveDraft || submitBtn"
                                  (saveDraft)="saveDraftAndReset(formDirective)" />
                <button color="accent"
                        [disabled]="submitBtn || draftEditor.saving() || transferFundsForm.invalid || transferFundsForm.get('amount')?.value <= 0"
                        class="mat-accent submit-btn"
                        type="submit"
                        mat-raised-button>
                    {{ isUserPartner ? 'Submit For Account Approval' : 'Submit For Partner Approval' }}
                </button>
            </div>
        </form>
    </div>
</div>
